"use client";

import { useState, useEffect } from "react";
import OnboardingWizard from "./OnboardingWizard";

export default function LoginWizard() {
  const [showOnboarding, setShowOnboarding] = useState(true);

  useEffect(() => {
    // Show onboarding on first visit (you can use localStorage to track this)
    const hasVisited = localStorage.getItem("has-visited");
    if (hasVisited) {
      setShowOnboarding(false);
    } else {
      localStorage.setItem("has-visited", "true");
    }
  }, []);

  const handlePreferencesComplete = (preferences: Record<number, number[]>) => {
    setShowOnboarding(false);
  };

  return (
    <OnboardingWizard
      isOpen={showOnboarding}
      onComplete={handlePreferencesComplete}
      onClose={() => setShowOnboarding(false)}
    />
  );
}
